import { useState } from 'react'
import { doc, updateDoc } from 'firebase/firestore'
import { useToast } from '@chakra-ui/react'
import { AdditionalDetails } from '../../../../../types/FirestoreUser'
import { removeUndefinedFields } from '../utils'
import { getEffectiveServices } from '../../../../../utils/firebaseServiceContext'

const useSubmitAdditionalDetails = (
  uid: string,
  additionalDetails: Partial<AdditionalDetails>,
  isMine: boolean,
) => {
  const [loading, setLoading] = useState(false)
  const toast = useToast()

  const submit = async () => {
    if (isMine) {
      if (!uid) return alert('Not logged in!')

      setLoading(true)

      try {
        const userRef = doc(getEffectiveServices().firestore, 'users', uid)
        const cleanedDetails = removeUndefinedFields(additionalDetails)
        await updateDoc(userRef, {
          additionalDetails: cleanedDetails,
        })

        toast({
          status: 'success',
          title: 'Saved',
          description: 'Additional details were successfully saved!',
          isClosable: true,
        })
      } catch (e) {
        console.error(e)
        toast({
          status: 'error',
          title: 'Error',
          description: 'An error occurred while saving additional details.',
          isClosable: true,
        })
      } finally {
        setLoading(false)
      }
    }
  }

  const saveSilently = async () => {
    if (isMine) {
      if (!uid) return

      try {
        const userRef = doc(getEffectiveServices().firestore, 'users', uid)
        const cleanedDetails = removeUndefinedFields(additionalDetails)
        await updateDoc(userRef, {
          additionalDetails: cleanedDetails,
        })
      } catch (e) {
        // autosave failed silently
      }
    }
  }

  return { submit, loading, saveSilently }
}

export default useSubmitAdditionalDetails
